import { AppBar, Toolbar, IconButton, Typography, Button } from "@mui/material"
import ExpandMoreRounded from '@mui/icons-material/ExpandMoreRounded'
import AppMenu from "./menu"
import { useState } from "react"
import { observer } from "mobx-react-lite"
import schemes from "../../schemes"
import appStore from "../../store"
import IconPracticum from "../icons/logo-p"

const Header = observer(() => {

  const [ menuOpen, setMenuOpen ] = useState(false)

  return (
    <AppBar position="static">
      <Toolbar>
        <IconButton
          size="large"
          edge="start"
          color="inherit"
          aria-label="menu"
          sx={{ mr: 2 }}
        >
          <IconPracticum fontSize="large" />
        </IconButton>
        <AppMenu open={menuOpen} onClose={() => setMenuOpen(false)}>
          <Button variant="text" sx={{ color: "primary.contrastText", textTransform: "none" }} onClick={() => setMenuOpen(true)}>
            <Typography variant="h6" component="div">
              { schemes[appStore.currentScheme].name }
            </Typography>
            <ExpandMoreRounded sx={{ ml: 1 }}/>
          </Button>
        </AppMenu>
      </Toolbar>
    </AppBar>
  )
})

export default Header